import React from "react";
import {primaryTextColour, subduedTextColour} from "../../style/styleConsts";
import IdeaCounts from "../idea/IdeaCounts";
import SubHeading from "../elements/SubHeading";
import {Td, Th} from "../elements/Tables";

export const ActivityBreakdown = (props) => (
    <div>
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
            <SubHeading>Activity Breakdown</SubHeading>
            <div style={{color: subduedTextColour}}>Trailing 12 months</div>
        </div>
        <div>
            <IdeasDescription summary={props.breakdown.summary} />
            <ActivitySection header="Regions" data={props.breakdown.regions}/>
            <ActivitySection header="Sectors" data={props.breakdown.sectors}/>
            <ActivitySection header="Market Caps" data={props.breakdown.marketCaps}/>
            <ActivitySection header="Holding Periods" data={props.breakdown.holdingPeriods}/>
        </div>
    </div>
);

const IdeasDescription = (props) => (
    <div style={{display: "flex", marginBottom: 20}}>
        <div>
            <div style={{color: subduedTextColour}}>Ideas</div>
            <div className="t-ideas-count" style={{fontSize: 24}}>{props.summary.ideas}</div>
        </div>
        <div style={{paddingLeft: 60}}>
            <div style={{color: subduedTextColour}}>New Ideas</div>
            <div className="t-new-ideas-count" style={{fontSize: 24}}>{props.summary.newIdeas}</div>
        </div>
    </div>
);

function ActivitySection(props) {
    const className = "t-" + props.header.split(" ").join("-").toLowerCase();
    return <div style={{marginBottom: 20}}>
        <table style={{borderCollapse: "collapse"}}>
            <thead>
            <tr>
                <Th name="header" width={195} style={{fontWeight: "bold", color: primaryTextColour, fontSize: 16}}>{props.header}</Th>
                <Th name="ideas" style={{color: subduedTextColour}} width={200}>Ideas</Th>
            </tr>
            </thead>
            <tbody className="t-sectors-table">
            {props.data.map(row =>
                <tr key={row.name}>
                    <Td className={className + "-name"}>
                        <div style={{display: "flex"}}>
                          <div style={{marginLeft: 10, width: props.header === "Market Caps" ? 65 : "inherit"}}>{row.name}</div>
                          {row.description ?
                              <div style={{color: subduedTextColour}}>{row.description}</div>
                              : null
                          }
                        </div>
                    </Td>
                    <Td>
                        <div className={className} style={{display: "flex"}}>
                            <div style={{width:35}}>{row.longs + row.shorts}</div>
                            <IdeaCounts openIdeas={row} allIdeaCounts={true}/>
                        </div>
                    </Td>
                </tr>
            )}
            </tbody>
        </table>
    </div>;
}